<template>
    <div class="row">
      <div class="col-6 pt-2">
        <div id="toggles" v-tooltip="'Book This competition for Pre Fixture'">
          <input type="checkbox" class="ios-toggle" @change="postStatus"  v-model="status" :id="'oucc_'+id" :name="'oucc_'+id" :checked="(status == '1') ? 'checked' : ''">
            <label :for="'oucc_'+id" class="checkbox-label"></label>
        </div>
      </div>
      <div class="col-6" v-tooltip="'Set Market Template for this event for Live/Pre'">
        <select @change="postTemplate" style="width: 150px" name="xxx" v-model="template" class="form-control pull-right">
          <option v-for="c in classes" :value="c.id">{{ c.name }}</option>
        </select>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'competitionTemplateSelect',
    props: ['classes','id'],
    data () {
      return {
        template: 0,
        status: false
      }
    },

    methods: {
      postTemplate() {
        this.$http.post(bsapi + 'api/v2/feedstation/competition/template?id='+this.id+'&template='+this.template+'&status='+this.status).then(response => {
          })
      },
      postStatus () {
        this.$http.post(bsapi + 'api/v2/feedstation/competition/status?id='+this.id+'&template='+this.template+'&status='+this.status).then(response => {
        })
      }
    },
    mounted () {
        this.$http.get(bsapi + 'api/v2/feedstation/competition/status', {
        params: {
          id: this.id,
          _: new Date().valueOf()
        }
      }).then(response => {
            this.template = response.body.template
            if (response.body.status == "1") {
              this.status = false
            }else {
              this.status = true
            }
      })
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  


// WEBPACK FOOTER //
// src/components/stats/widget/competitionTemplateSelect.vue